import { Outlet } from "react-router-dom";
import { Suspense } from "react";
import { Skeleton } from "@/components/Skeleton";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { ToastViewport } from "@/components/Toast";
import { ScrollToTop } from "@/components/ScrollToTop";

export function FunnelLayout() {
  return (
    <ErrorBoundary>
      <ScrollToTop />
      <div className="min-h-dvh flex flex-col bg-cream">
        <Suspense
          fallback={
            <div className="flex-1 p-6 flex flex-col gap-4">
              <Skeleton className="h-8 w-2/3" />
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-5/6" />
            </div>
          }
        >
          <main className="flex-1 animate-fade-in-up">
            <Outlet />
          </main>
        </Suspense>
        <ToastViewport />
      </div>
    </ErrorBoundary>
  );
}
